import { render, staticRenderFns } from "./CubeLoader.vue?vue&type=template&id=7dd62b08&scoped=true"
var script = {}
import style0 from "./CubeLoader.vue?vue&type=style&index=0&id=7dd62b08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd62b08",
  null
  
)

export default component.exports